import { Component } from '@angular/core';

@Component({
  selector: 'app-coming-soon-section',
  templateUrl: './coming-soon-section.component.html',
  styleUrls: ['./coming-soon-section.component.css']
})
export class ComingSoonSectionComponent {
  comingSoonFeatures = [
    {
      title: 'AI CV Screening',
      desc: 'Automatically screen and rank resumes based on job requirements using AI, helping recruiters identify the most qualified candidates in seconds.',
    },
    {
      title: 'Test banks',
      desc: 'Create reusable question libraries and structured assessments for different roles to ensure faster, more consistent candidate evaluation.',
    },
    {
      title: 'Head hunting',
      desc: 'Discover qualified professionals through AI-powered talent search and connect with passive candidates who match your hiring needs.',
    },
  ];
}
